var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V7H8C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9V12V15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17H9V18C9 18.5523 9.44772 19 10 19C10.5523 19 11 18.5523 11 18V17H12V18C12 18.5523 12.4477 19 13 19C13.5523 19 14 18.5523 14 18V17H14.5C16.1569 17 17.5 15.6569 17.5 14C17.5 13.09 17.0949 12.2747 16.4551 11.7245C16.7984 11.2367 17 10.6419 17 10C17 8.34315 15.6569 7 14 7V6C14 5.44772 13.5523 5 13 5C12.4477 5 12 5.44772 12 6V7H11V6ZM13 15H10V13H12H14H14.5C15.0523 13 15.5 13.4477 15.5 14C15.5 14.5523 15.0523 15 14.5 15H13ZM13 9H10V11H12H14C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9H13Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcStroke);
export default __webpack_public_path__ + "static/media/btc_stroke.19ffddfd27abbecc0c289b473facef04.svg";
export { ForwardRef as ReactComponent };